var GACode = "G-VCY9Y51ZS3";
var gtmElem = document.createElement("script");
gtmElem.src = "https://www.googletagmanager.com/gtag/js?id=" + GACode;
gtmElem.async = true;
document.querySelector("head").appendChild(gtmElem);